// Find the distinct field values in an array of dicts
export function findDistinct(fieldToFind, arrayToSearch) {

  if (arrayToSearch && Array.isArray(arrayToSearch)) {
    return arrayToSearch.reduce(function (carry, item) {
      if (item[fieldToFind] && !~carry.indexOf(item[fieldToFind])) {
        carry.push(item[fieldToFind]);
      }
      return carry;
    }, []);
  }
  return [];
}
